module.exports = __webpack_public_path__ + "static/img/jyzyIcon.1c073ab9.png";